import request from '../utils/request'
export const initAttendance = data => request.post('/attendances/init', data)
export const listAttendance = params => request.get('/attendances', { params })
export const createAttendance = data => request.post('/attendances', data)
export const checkIn = data => request.post('/attendances/check-in', data)
export const batchCheckIn = data => request.post('/attendances/batch-check-in', data)
export const checkOut = data => request.post('/attendances/check-out', data)
export const updateAttendance = (id, data) => request.patch(`/attendances/${id}`, data)
